import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { BASE_URL } from "../config";
import axios from 'axios';
import moment from 'moment';
import PieChart from '../components/pieChart';
import Confetti from '../components/confetti';
import Skeleton from 'react-loading-skeleton';
import goalImg from "../assets/images/goalImg.svg"
import stopwatchIcon from "../assets/images/stopwatchIcon.svg"
import historyIcon from "../assets/images/historyIcon.svg"
import timerIcon from "../assets/images/timerIcon.svg"
import caloriesIcon from "../assets/images/caloriesIcon.svg"
import winnerCup from "../assets/images/winnerCup.svg"
import RadialChart from '../components/radialChart';
import authStorage from "../utils/authStorage";

const SummaryGoals = ({ back }) => {
    const params = useParams();
    const [caloriesBurned, setCaloriesBurned] = useState({});
    const [timeConsumed, setTimeConsumed] = useState({});
    const [timeToCompleteGoal, setTimeToCompleteGoal] = useState(0);
    const [timeAcheived, settimeAcheived] = useState(0);
    const [monthlyTarget, setMonthlyTarget] = useState(0);
    const [timeToCompleteGoalPercentage, setTimeToCompleteGoalPercentage] = useState('');
    const [centerTextOne, setCenterTextOne] = useState('');
    const [centerTextTwo, setCenterTextTwo] = useState('');
    const [centerTextThree, setCenterTextThree] = useState('');
    const [startDate, setStartDate] = useState(moment().startOf('month').format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(moment().endOf('month').format('YYYY-MM-DD'));
    const [currentDay, setCurrentDay] = useState(moment().date());
    const [monthToSubtract, setMonthToSubtract] = useState(0);
    const [loading, setLoading] = useState(true); 
    let [garConnect, setGarConnect] = useState(false);
    const [fitConnect, setFitConnect] = useState(false);
	const [appleConnected, setAppleConnected] = useState(false);
	// isAppleConnected on the user doc only means "Apple was linked at some point".
	// Accounts exist with the flag set but zero Apple records (e.g. a Fitbit user who
	// linked Apple once), and treating those as Apple-sourced hid their Fitbit data
	// entirely. appleActive tracks whether Apple actually returned rows.
	const [appleActive, setAppleActive] = useState(false);
    const [gartokConnect, setGartokConnect] = useState(false);
    //const [walkThroughPending, setWalkThroughPending] = useState(JSON.parse(authStorage.getItem("walkthough")).walkThroughPending);
    //const [walkThroughSteps, setWalkThroughSteps] = useState(JSON.parse(authStorage.getItem("walkthough")).walkThroughSteps);
    const getWalkthroughData = () => {
        try {
            const stored = authStorage.getItem("walkthrough"); // Fixed spelling
            if (!stored) return { walkThroughPending: false, walkThroughSteps: [] };
            
            // If already an object
            if (typeof stored === 'object') {
                return {
                    walkThroughPending: stored.walkThroughPending ?? false,
                    walkThroughSteps: stored.walkThroughSteps ?? []
                };
            }
            
            // If string, parse it
            const parsed = JSON.parse(stored);
            return {
                walkThroughPending: parsed.walkThroughPending ?? false,
                walkThroughSteps: parsed.walkThroughSteps ?? []
            };
        } catch (error) {
            console.error("Error reading walkthrough data:", error);
            return { walkThroughPending: false, walkThroughSteps: [] };
        }
    };

    const [walkThroughPending, setWalkThroughPending] = useState(() => 
        getWalkthroughData().walkThroughPending
    );
    const [walkThroughSteps, setWalkThroughSteps] = useState(() => 
        getWalkthroughData().walkThroughSteps
    );
    const [count ,setCount]=useState(0);
    const navigate = useNavigate();
    useEffect(() => {

        let subscribedStatus = authStorage.getItem('subscribedStatus');

        // If subscribedStatus is falsy, redirect to membership page
        if (subscribedStatus == 'false') {
            window.location = window.location.origin + '/membership';
            return false;
        } else if (fitConnect == 'false' && garConnect == 'false' && appleConnected == 'false') {
            navigate('/device');
            back(0);
        }
        //  else if (walkThroughPending =='true' || walkThroughSteps !== "2") {
        //     navigate('/device'); 
        //     back(0)
        // }
    });

    const convertMinsToHrsMins = (mins) => {

        if (!mins) {
            return '0 hr 0 min';
        }
        let h = Math.floor(mins / 60);
        let m = mins % 60;
        h = h < 10 ? '0' + h : h; // (or alternatively) h = String(h).padStart(2, '0')
        m = m < 10 ? '0' + m : m; // (or alternatively) m = String(m).padStart(2, '0')
        return `${h} hr ${m} min`;
    }
	
	const isFitbitOnly = fitConnect && !garConnect && !appleActive;

    // OLD CODE:
    // const dataOne = [
    //     { name: 'Achieved', value: parseInt(timeConsumed?.light + timeConsumed?.moderate + timeConsumed?.vigorous), ...},
    //     { name: 'Remaining', value: parseInt(timeToCompleteGoal), ...},
    // ];

    // NEW CODE:
    const achievedValue = (fitConnect && !garConnect && !appleConnected)
        ? ((timeConsumed?.moderate > 0 || timeConsumed?.vigorous > 0)
            ? parseInt((timeConsumed?.light || 0) + (timeConsumed?.moderate * 2) + (timeConsumed?.vigorous * 2))   // Fitbit: light×1 + vigorous×2 + peak×2
            : parseInt(timeConsumed?.light || 0))                                      // Fitbit: moderate only
        : parseInt(timeConsumed?.light + timeConsumed?.moderate + timeConsumed?.vigorous);  // Garmin/Apple

    const dataOne = [
        { name: 'Achieved', value: achievedValue, dataAvg: count ? Math.round(achievedValue / count) : 0, itemStyle: { color: '#239523' } },
        { name: 'Remaining', value: parseInt(timeToCompleteGoal), dataAvg: count ? Math.round((timeToCompleteGoal) / count) : 0, itemStyle: { color: '#0694F3' } },
    ];
    const dataTwo = isFitbitOnly
		? [
			{ name: 'Moderate', value: parseInt(timeConsumed?.light || 0), dataAvg: count ? Math.round((timeConsumed?.light) / count) : 0, itemStyle: { color: '#0694F3' } },
			{ name: 'Vigorous', value: parseInt((timeConsumed?.moderate || 0) * 2), dataAvg: count ? Math.round(((timeConsumed?.moderate || 0) * 2) / count) : 0, itemStyle: { color: '#FF8B20' } },
			{ name: 'Peak', value: parseInt((timeConsumed?.vigorous || 0) * 2), dataAvg: count ? Math.round(((timeConsumed?.vigorous || 0) * 2) / count) : 0, itemStyle: { color: '#F50F51' } },
		]
		: [
			{ name: 'Moderate', value: parseInt(timeConsumed?.light || 0), dataAvg: count ? Math.round((timeConsumed?.light) / count) : 0, itemStyle: { color: '#0694F3' } },
			{ name: 'Vigorous', value: parseInt(timeConsumed?.moderate || 0), dataAvg: count ? Math.round((timeConsumed?.moderate) / count) : 0, itemStyle: { color: '#FF8B20' } },
			{ name: 'Peak', value: parseInt(timeConsumed?.vigorous || 0), dataAvg: count ? Math.round((timeConsumed?.vigorous) / count) : 0, itemStyle: { color: '#F50F51' } },
		];
    const dataThree = [
        { name: 'Moderate', value: parseInt(caloriesBurned?.light || 0), dataAvg: count ? Math.round((caloriesBurned?.light )/count) : 0,itemStyle: { color: '#0694F3' } },
        { name: 'Vigorous', value: parseInt(caloriesBurned?.moderate || 0),dataAvg: count ? Math.round((caloriesBurned?.moderate )/count) : 0, itemStyle: { color: '#FF8B20' } },
        { name: 'Peak', value: parseInt(caloriesBurned?.vigorous || 0), dataAvg: count ? Math.round((caloriesBurned?.vigorous )/count) : 0,itemStyle: { color: '#F50F51' } },
    ]

    // Total & Avg AZM for Fitbit, raw minutes for others
    const totalValidTime = isFitbitOnly
		? ((timeConsumed?.moderate > 0 || timeConsumed?.vigorous > 0)
			? parseInt((timeConsumed?.light || 0) + (timeConsumed?.moderate * 2) + (timeConsumed?.vigorous * 2))
			: parseInt(timeConsumed?.light || 0))
		: parseInt(timeConsumed?.light + timeConsumed?.moderate + timeConsumed?.vigorous);
	
	// Helper variables (add next to totalValidTime):
	const totalValidKcals = isFitbitOnly
		? ((timeConsumed?.moderate > 0 || timeConsumed?.vigorous > 0)
			? parseInt((caloriesBurned?.light || 0) + (caloriesBurned?.moderate || 0) + (caloriesBurned?.vigorous || 0))
			: parseInt(caloriesBurned?.light || 0))
		: parseInt((caloriesBurned?.light || 0) + (caloriesBurned?.moderate || 0) + (caloriesBurned?.vigorous || 0));

	const avgValidKcals = count ? Math.round(totalValidKcals / count) : 0;

    const avgValidTime = count
        ? Math.round(totalValidTime / count)
        : 0;
	
    const getUserActivityRecord = async (event) => {
        setLoading(true);
        let userId = authStorage.getItem("userId");

        let device = "FitBit";
        let url = '';
		
		console.log("fitConnect : ", fitConnect);
        console.log("garConnect : ", garConnect);
        console.log("appleConnected : ", appleConnected);

        const fitbitUrl = `${BASE_URL}/user/getfitbitexercisedata/${startDate}/${endDate}`;
        const garminUrl = `${BASE_URL}/user/getgarminexercisedatabydate/${startDate}/${endDate}`;
        const appleUrl = `${BASE_URL}/apple/getapplehealthdatabydate/${startDate}/${endDate}/${userId}`;

         let fitbitData = await axios({
             headers: {
                 "x-access-token": authStorage.getItem("auth-token")
             },
             url: fitbitUrl,
             method: 'GET'
         });

        let garminData = await axios({
            headers: {
                "x-access-token": authStorage.getItem("auth-token")
            },
            url: garminUrl,
            method: 'GET'
        });

        if(appleConnected){
            let appleData = await axios({
                headers: {
                    "x-access-token": authStorage.getItem("auth-token")
                },
                url: appleUrl,
                method: 'GET'
            });

            // Only switch the aggregation source to Apple when Apple actually returned
            // rows. Previously this ran on the isAppleConnected flag alone, which set
            // garConnect = true and made the Fitbit branch below unreachable, so a
            // Fitbit user with a stale Apple flag saw an empty summary.
            const hasAppleData = !!appleData?.data?.data?.length;
            setAppleActive(hasAppleData);

            if (hasAppleData) {
                garminData = appleData;
                garConnect = appleConnected;
            }
        }

        console.log('------*#*------', garminData?.data?.data);
        console.log('garminData.length : ', garminData.length);

        

        setLoading(false);
        let tempCaloriesBurned = {
            light: 0,
            moderate: 0,
            vigorous: 0
        };
        let tempTimeConsumed = {
            light: 0,
            moderate: 0,
            vigorous: 0
        };
		
		if(!garConnect && fitConnect){
		//if (Array.isArray(garminData?.data?.data) && !garminData.data.data.length) {
			fitbitData = fitbitData?.data?.data;
			
			let cCount = 0;
			fitbitData?.map((data) => {
				if(Math.round(data?.heartRateZones[1].minutes) > 0){
					cCount++;
				}
				tempCaloriesBurned.light = Math.round(data?.heartRateZones[1].caloriesOut) + tempCaloriesBurned.light;
				tempCaloriesBurned.moderate = Math.round(data?.heartRateZones[2].caloriesOut) + tempCaloriesBurned.moderate;
				tempCaloriesBurned.vigorous = Math.round(data?.heartRateZones[3].caloriesOut) + tempCaloriesBurned.vigorous;
				tempTimeConsumed.light = Math.round(data?.heartRateZones[1].minutes) + tempTimeConsumed.light;
				tempTimeConsumed.moderate = Math.round(data?.heartRateZones[2].minutes) + tempTimeConsumed.moderate;
				tempTimeConsumed.vigorous = Math.round(data?.heartRateZones[3].minutes) + tempTimeConsumed.vigorous;
				
				console.log("moderate", Math.round(data?.heartRateZones[1].minutes));
			});
			setCount(cCount)
			
			//console.log("cCount : ", cCount);
			
			
		}
		
		setCaloriesBurned(tempCaloriesBurned);
        setTimeConsumed(tempTimeConsumed);
		
		if((!fitConnect && garConnect) || (fitConnect && garConnect)){
		//if (Array.isArray(garminData?.data?.data) && garminData.data.data.length) {
			console.log("cCount : ", 4);
			tempCaloriesBurned = {
				light: 0,
				moderate: 0,
				vigorous: 0
			};
			tempTimeConsumed = {
				light: 0,
				moderate: 0,
				vigorous: 0
			};
			
			let cCount = 0;
			
			garminData = garminData?.data?.data;
			
			garminData?.map((data) => {
				let timeSpend = {};
				let calorieConsumed = {};
			   
				//setCount(garminData.length)
				data?.heartRateZones?.map((data) => {
					//timeSpend[data?.heartZoneName] = data?.minutes;
					timeSpend[data?.heartZoneName] = Math.ceil(Number(data?.minutes || 0)); //new line
					calorieConsumed[data?.heartZoneName] = data?.caloriesOut;
				});
				
				if(Math.round(timeSpend?.light) > 0){
					
					if(Math.round(timeSpend?.light) > 0){
						cCount++;
					}
					
					tempCaloriesBurned.light = Math.round(calorieConsumed?.light) + tempCaloriesBurned.light;
					tempCaloriesBurned.moderate = Math.round(calorieConsumed?.moderate) + tempCaloriesBurned.moderate;
					tempCaloriesBurned.vigorous = Math.round(calorieConsumed?.vigorous) + tempCaloriesBurned.vigorous;
					tempTimeConsumed.light = Math.round(timeSpend?.light) + tempTimeConsumed.light;
					tempTimeConsumed.moderate = Math.round(timeSpend?.moderate) + tempTimeConsumed.moderate;
					tempTimeConsumed.vigorous = Math.round(timeSpend?.vigorous) + tempTimeConsumed.vigorous;
					
				}
				
				
			});
			setCount(cCount)
			console.log("cCount-- ", cCount)
		}

        setCaloriesBurned(tempCaloriesBurned);
        setTimeConsumed(tempTimeConsumed);
		
		//console.log("tempTimeConsumed : ", tempTimeConsumed);
    };

    useEffect(() => {
        getUserActivityRecord();
        const currentDateNumber = Date.now();
    }, [endDate, fitConnect, garConnect, appleConnected]);

    useEffect(() => {
        // front End  Moderate = backend Light
        // front End  vigorous = backend Moderate
        // front End  peak = backend vigorous
        let { vigorous, moderate, light } = timeConsumed; 
        
        vigorous = Math.round(vigorous);
        moderate = Math.round(moderate);
        light = Math.round(light);
		
		console.log("vigorous : ", vigorous)
		console.log("moderate : ", moderate)
		console.log("light : ", light)
        
        let tempMonthlyTarget = 0;
        let achievedTime = 0;

        if (fitConnect && !garConnect && !appleConnected) {
            // FITBIT ONLY: Apply 2x AZM (Activity Zone Minutes) multiplier
            // light    = Fat Burn  = Moderate → 1x
            // moderate = Cardio    = Vigorous → 2x Zone Data
            // vigorous = Peak      = Peak     → 2x Zone Data
            tempMonthlyTarget = 600; // Always 600 AZM for Fitbit
			
            //achievedTime = (light * 1) + (moderate * 2) + (vigorous * 2);
			
			if (moderate > 0 || vigorous > 0) {
                // Has vigorous/peak data → 600 AZM (only vigorous×2 + peak×2)
                achievedTime = light + (moderate * 2) + (vigorous * 2);
            } else {
                // No vigorous/peak → 600 moderate (raw) minutes
                achievedTime = light;
            }
        } else {
            // GARMIN / APPLE: Keep old logic
            achievedTime = light + moderate + vigorous;
            if (moderate === 0) {
                tempMonthlyTarget = 600;
            }
            if (moderate >= 1) {
                tempMonthlyTarget = 300;
            }
        }
		
		console.log("achievedTime : ", achievedTime)
		console.log("tempMonthlyTarget : ", tempMonthlyTarget)
		
        setMonthlyTarget(tempMonthlyTarget);
        setTimeToCompleteGoal(Math.max(tempMonthlyTarget - achievedTime, 0));
        settimeAcheived(achievedTime);
        // setTimeToCompleteGoal(tempMonthlyTarget - totalTime);
        setTimeToCompleteGoalPercentage(Math.round((tempMonthlyTarget - achievedTime) / tempMonthlyTarget * 100));
        const timeLeft = tempMonthlyTarget - achievedTime;
        const percentage = timeLeft >= 0 ? 100 - Math.round((timeLeft / tempMonthlyTarget) * 100) : 100 + Math.round(Math.abs((timeLeft / tempMonthlyTarget) * 100));

        setCenterTextOne(`${percentage}% of goal \n ${convertMinsToHrsMins(timeLeft >= 0 ? parseInt(timeLeft) : 0)} \nto go`);
        // setCenterTextOne(`${100 - parseInt((tempMonthlyTarget - totalTime) / tempMonthlyTarget * 100) || 0}% of \n ${convertMinsToHrsMins(parseInt(tempMonthlyTarget - totalTime))} \nto go`);
        const totalTimeForChart = (fitConnect && !garConnect && !appleConnected)
			? ((moderate > 0 || vigorous > 0)
				? parseInt(light + (moderate * 2) + (vigorous * 2))
				: parseInt(light))
			: parseInt(light + moderate + vigorous);
		
		setCenterTextTwo(`${convertMinsToHrsMins(totalTimeForChart)} \nTotal Time*`);
		
        setCenterTextThree(`${parseInt(caloriesBurned?.moderate + caloriesBurned?.vigorous + caloriesBurned?.light)} \nTotal Calories Burn *`);
    }, [timeConsumed]);

    const clickNextMonth = () => {
        if (parseInt(monthToSubtract) <= 0) {
            return;
        }
        setMonthToSubtract(monthToSubtract - 1);
    };

    const clickPreviousMonth = () => {
        if (parseInt(monthToSubtract) >= 2) {
            return;
        }
        setMonthToSubtract(monthToSubtract + 1);
    };

    useEffect(() => {
        let selectedStartDate = moment().subtract(monthToSubtract, 'months').startOf('month').format('YYYY-MM-DD');
        let selectedEndDate = moment().subtract(monthToSubtract, 'months').endOf('month').format('YYYY-MM-DD');
        setStartDate(selectedStartDate);
        setEndDate(selectedEndDate);
    }, [monthToSubtract]);
    useEffect(() => {
        const getDeviceStatus = async () => {
            try {
                const res = await axios({
                    headers: {
                        "x-access-token": authStorage.getItem("auth-token"),
                    },
                    url: `${BASE_URL}/user/device/status`,
                    method: "GET",
                });
                setGarConnect(res.data.isGarminConnected);
                setFitConnect(res.data.isFitbitConnected);
				setAppleConnected(res.data.isAppleConnected);
                setGartokConnect(res.data.isGarminConnectedthroughtoken);
                
                if (!res.data.isGarminConnected && !res.data.isFitbitConnected && !res.data.isAppleConnected) {

                    navigate('/device'); back(0);
                }
            } catch (err) {
                if (err.code === "ERR_BAD_REQUEST") {
                    // Handle error
                }
            }
        };

        getDeviceStatus();
        
    }, []);

    

    return (
        <>
            <div className="sm:p-auto summary-goal-container">
                <div className="wrapper">
                <h2 className="mob-header font-medium mb-5">Summary-Goals</h2>
                    <div className="summary-chart-main">
                        <div className="summary-chart-section">
                            <h3>
                                {moment(endDate).format('MMMM')}
                            </h3>
                            <div className="flex flex-wrap justify-center items-start pb-6 md:pb-14 ">
                                <div className="">
                                    {loading ? (
                                        <Skeleton baseColor="#cccccc" highlightColor="#fff" height={'284px'} width={'300px'} className="m-2" />
                                    ) : (
                                        <RadialChart data={dataOne} centerText={centerTextOne} chartNO="1" />
                                        // <PieChart data={dataOne} centerText={centerTextOne} />
                                    )}
                                </div>
                                <div className="">
                                    {loading ? (
                                        <Skeleton baseColor="#cccccc" highlightColor="#fff" height={'284px'} width={'300px'} className="m-2" />
                                    ) : (
                                        <RadialChart data={dataTwo} centerText={centerTextTwo} chartNO="2" />
                                        // <PieChart data={dataTwo}  />
                                    )}
                                </div>
                                <div className="">
                                    {loading ? (
                                        <Skeleton baseColor="#cccccc" highlightColor="#fff" height={'284px'} width={'300px'} className="m-2" />
                                    ) : (
                                        <RadialChart data={dataThree} centerText={centerTextThree} chartNO="3" />
                                        // <PieChart data={dataTwo}  />
                                    )}
                                </div>
                            </div>
                            <div className="default-btn-outer">
                                <button disabled={loading} onClick={() => clickPreviousMonth()} type="button" style={{ zIndex: 1 }} className={`${(parseInt(monthToSubtract) >= 2) ? 'bg-gray-600 cursor-not-allowed light-default-btn' : 'cursor-pointer bg-red-btn '} default-btn prev-btn dark:focus:ring-[#E53E14]/55`}>
                                    Previous
                                </button>
                                <button disabled={loading} onClick={() => clickNextMonth()} type="button" style={{ zIndex: 1 }} className={`${(parseInt(monthToSubtract) <= 0) ? 'bg-gray-600  cursor-not-allowed light-default-btn' : 'cursor-pointer bg-red-btn '} default-btn next-btn dark:focus:ring-[#E53E14]/55`}>
                                    Next
                                </button>
                            </div>
                        </div>

                        {(timeToCompleteGoalPercentage <= 0) ? (
                            
                            <div className="summary-right-box winner-box">
                                <div className="summary-img-box">
                                    <img src={winnerCup} />
                                    <div className="content-head">
                                        <h4>
												{convertMinsToHrsMins(totalValidTime)}
											</h4>
                                        <p>you have achieved goal</p>
                                    </div>
                                </div>
                                <div className="monthly-summary-box">
                                    <h5>Monthly Summary</h5>
                                    <ul>
										
										<li><span className="icon-img"><img src={stopwatchIcon} /></span> <span className="list-text">Total Valid Time <span className="time">{`${totalValidTime} min`}</span></span></li>
                                        <li><span className="icon-img"><img src={historyIcon}/></span> <span className="list-text"> Avg. Valid Time <span className="time">{`${avgValidTime} min`}</span></span></li>
                                        <li><span className="icon-img"><img src={caloriesIcon} /></span> <span className="list-text">Total Valid Kcals <span className="time">{`${totalValidKcals} Cal`}</span></span></li>
										<li><span className="icon-img"><img src={caloriesIcon} /></span> <span className="list-text">Avg. Valid Kcals <span className="time">{`${avgValidKcals} Cal`} Kcal</span></span></li>
                                    </ul>
                                </div>
                            </div>
                        ) : (
                            
                            <div className="summary-right-box">
                                <div className="summary-img-box">
                                    <img src={goalImg} />
                                    <div className="content-head">
                                        <h4>{convertMinsToHrsMins(parseInt(timeToCompleteGoal))}. to go</h4>
                                        <p>You have {convertMinsToHrsMins(parseInt(timeToCompleteGoal))} left to achieve
                                            your exercise goal.</p>
                                    </div>
                                </div>
                                <div className="monthly-summary-box">
                                    <h5>Monthly Summary</h5>
                                    <ul>
                                        <li><span className="icon-img"><img src={stopwatchIcon} /></span> <span className="list-text">Total Valid Time <span className="time">{`${totalValidTime} min`}</span></span></li>
                                        <li><span className="icon-img"><img src={historyIcon}/></span> <span className="list-text"> Avg. Valid Time <span className="time">{`${avgValidTime} min`}</span></span></li>
                                        <li><span className="icon-img"><img src={caloriesIcon} /></span> <span className="list-text">Total Valid Kcals <span className="time">{`${totalValidKcals} Cal`}</span></span></li>
										<li><span className="icon-img"><img src={caloriesIcon} /></span> <span className="list-text">Avg. Valid Kcals <span className="time">{`${avgValidKcals} Cal`} Kcal</span></span></li>
                                    </ul>
                                </div>
                            </div>
                        )}
                    </div>
                    
                </div>
            </div>
        </>
    )
}
export default SummaryGoals;
